import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const PostNotificationSlice = createSlice({
    name: "postNotification",
    initialState,
    reducers: {
        postNotificationRequest(state) {
            state.loading = true;
        },
        postNotificationRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        postNotificationRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        postNotificationStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    postNotificationRequest,
    postNotificationRequestSuccess,
    postNotificationRequestError,
    postNotificationStateReset
} = PostNotificationSlice.actions;

export default PostNotificationSlice.reducer;
